import Experience from "./Experience"

export default function Timeline({ careers, toggleCareer }) {
    const up = getExperiences(careers, 0)
    const down = getExperiences(careers, 1)

    function getExperiences(careers, i) {
        return careers.filter(
            (obj, key) => (key % 2) == i
        )
    }

    function render(e) {
        return (
            <Experience
                experience={e}
                key={careers.indexOf(e)}
                setEnabled={() => toggleCareer(e)}
            />
        )
    }

    return (
        <div className="timeline w-100">
            <div className="up">
                { up.map(render) }
            </div>
            <div className="line w-100">
            </div>
            <div className="down">
                { down.map(render) }
            </div>
        </div>
    )
}